import './init_Jquery';

import * as bootstrap from 'bootstrap';
import 'jquery-ui/dist/jquery-ui.min';

import toastr from 'toastr';
import 'intl-tel-input/build/js/intlTelInput-jquery';

import './cable';
import './helpers';

import './address_autocomplete';
import './document_name';
import './hide_show_password';
import './mobile_profile_nav';
import './subscription_expiration';
import './subscribe_modal';
import './file_drop';
import './users/profile';
import './show_credit_with_fees';

import './controllers';
import Rails from '@rails/ujs';
window.bootstrap = bootstrap;
window.toastr = toastr;

Rails.start();
window.Rails = Rails;

$(document).ready(function () {
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  });

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });

  $('body').on('change', '.file-input', function () {
    if ($(this)[0].files[0] !== undefined) {
      $(this)
        .parent()
        .find('.label-wording')
        .html($(this)[0].files[0].name);
    }
  });
});
